import { useMemo } from 'preact/hooks';
import { FormFieldContextProps } from '../UNSAFE_useFormFieldContext';

type UseTextFieldProps = {
  hasValue?: boolean;
  isDisabled?: boolean;
  isFocused?: boolean;
  isInputFocused?: boolean;
  isLoading?: boolean;
  isReadonly?: boolean;
};

/**
 * A custom hook to determine props to set FormFieldContext
 */
export function useFormFieldContextProps({
  hasValue,
  isDisabled,
  isFocused,
  isInputFocused,
  isLoading,
  isReadonly
}: UseTextFieldProps) {
  return useMemo<FormFieldContextProps>(() => {
    return isReadonly
      ? {
          hasValue,
          isFocused,
          isInputFocused,
          isLoading,
          isReadonly: true
        }
      : isDisabled
      ? {
          hasValue,
          isDisabled: true,
          isLoading
        }
      : {
          hasValue,
          isFocused,
          isInputFocused,
          isLoading
        };
  }, [hasValue, isDisabled, isFocused, isInputFocused, isLoading, isReadonly]);
}
